import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class CustomModulesComponent extends Component {
  @service session;

  get customData() {
    return this.args.custom_date || this.args.item?.modules_json?.moduli;
  }
}
